export default __webpack_public_path__ + "directory-bdm-500-7818db3b3bfe9cba5bc8560b72be4a68.webp";